export default __webpack_public_path__ + "locales/de/ArchiveDialog.json?hash=805f0dacb2db8ca0a1e4a2da4471489f";